import React from "react";
import { getCachedBranding } from "../../lib/branding";

export const AuthLoadingScreen = ({
  message = "Inicializando aplicação...",
}) => {
  // Nome da loja da última visita (a API ainda não respondeu nesta tela).
  // Sem cache (primeira visita) não mostra nome: nunca exibe dados de outra loja.
  const storeName = getCachedBranding()?.name || "";

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          {/* Logo ou imagem de loading */}
          <div className="w-24 h-24 mx-auto mb-4 relative">
            <div className="absolute inset-0 bg-brand-600 rounded-xl shadow-lg animate-pulse"></div>
            <div className="absolute inset-2 bg-white rounded-lg flex items-center justify-center">
              <div className="w-8 h-8 border-4 border-brand-600 border-t-transparent rounded-full animate-spin"></div>
            </div>
          </div>
        </div>

        {storeName && (
          <h2 className="text-xl font-bold text-cocoa mb-2">{storeName}</h2>
        )}
        <p className="text-cocoa-muted font-medium">{message}</p>

        {/* Indicador de progresso */}
        <div className="mt-4 w-48 mx-auto">
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-brand-600 rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
